import { StepsUI } from "../../../modules";

const Steps = () => {
  return <StepsUI />;
};

export { Steps };
